<template>
  <q-page fluid class="row">
    <div style="max-height: calc(100vh - 82px)" class="row full-width">
      <div class="col-12 col-md-6 q-pa-sm">
        <q-card>
          <q-card-section class="bg-primary text-white">
            <div class="row items-center">
              <div
                style="display: inline-block; font-family: 'Outfit', cursive"
                class="text-h6"
              >
                Scheduled Surveys
              </div>
              <q-btn
                class="q-ml-md"
                color="white"
                text-color="white"
                icon="mdi-plus"
                flat
                @click="newDialog = true"
                v-if="currentUserData.role == 'Admin'"
              ></q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                dark
                standout
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"></q-icon>
                </template>
              </q-input>
            </div>
            <div class="row" v-if="currentUserData.role == 'Admin'">
              <div class="col-12 col-sm-6">
                <assign-organization
                  :id="filter.organization_id"
                  label="Organisation"
                  clearable
                  dark
                  @changed="organizationFilterChanged"
                />
              </div>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="scheduledSurveys">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  :style="`height: calc(100vh - ${
                    currentUserData.role == 'Admin' ? '225px' : '170px'
                  }) !important`"
                >
                  <datatable
                    :filter="filter"
                    :flat="true"
                    :data="scheduledSurveys"
                    :columns="columns"
                    :externalFilter="externalFilter"
                    @rowSelected="handleDoubleClick"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-location" slot-scope="data">
                      <q-td :props="data.props">
                        {{ data.props.row.location }}
                        <q-tooltip>{{ data.props.row.location }}</q-tooltip>
                      </q-td>
                    </template>
                    <template slot="body-cell-name" slot-scope="data">
                      <q-td :props="data.props">
                        {{ data.props.row.name }}
                        <q-tooltip>{{ data.props.row.name }}</q-tooltip>
                      </q-td>
                    </template>
                    <template
                      v-if="currentUserData.role == 'Admin'"
                      slot="body-cell-archive"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-btn
                          @click.stop="archiveSurvey(data.props.row.id)"
                          color="secondary"
                          flat
                          icon="mdi-delete"
                          round
                          :loading="deletingSurveyID == data.props.row.id"
                        >
                          <q-tooltip>Archive Survey</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
      <div class="col-12 col-md-6 q-pa-sm" style="height: calc(100%)">
        <scheduledSurveysClustorMap @viewSurvey="handleDoubleClick" />
      </div>
    </div>

    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              New Scheduled Survey
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-plus"
                label="Create"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div
              style="display: inline-block; font-family: 'Outfit', cursive"
              class="text-h6"
            >
              Survey
            </div>
            <q-space />
            <q-btn color="white" round flat icon="mdi-close" @click="close">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <scheduledSurveyForm
            ref="editForm"
            @close="close"
            @loadingStateChanged="(state) => (saveLoading = state)"
            @uploadDataLoading="(state) => (dataUploadLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.uploadData()"
                :loading="dataUploadLoading"
                text
                color="primary"
                class="float-left"
                icon="upload"
                label="Upload Data"
              >
              </q-btn>
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import agGrid from "@/components/agGrid";
import expandedToolbar from "@/components/expandedToolbar";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import placesAutocomplete from "@/components/googleMaps/placesAutocomplete.vue";
import datepicker from "@/components/wrappers/datepicker.vue";
import scheduledSurveyForm from "@/components/scheduledSurveys/scheduledSurveyForm.vue";
import scheduledSurveysClustorMap from "@/components/scheduledSurveys/scheduledSurveysClustorMap.vue";
import moment from "moment";
import AssignOrganization from "../components/organizations/assignOrganization.vue";

// import { Notify } from "quasar";

export default {
  components: {
    agGrid,
    expandedToolbar,
    datatable,
    placesAutocomplete,
    datepicker,
    scheduledSurveyForm,
    scheduledSurveysClustorMap,
    AssignOrganization,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentUserData",
      "selectedRowData",
      "aGGridActionMenu",
      "scheduledSurveys",
      "scheduledSurveysLoading",
      "organizationSurveyLinks",
    ]),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "archive",
        label: "",
        align: "left",
        field: "",
        sortable: true,
      },
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "date",
        label: "Date",
        align: "left",
        field: "date",
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),
        sortable: true,
      },
      {
        name: "location",
        label: "Location",
        align: "left",
        field: "location",
        sortable: true,
      },
      {
        name: "assignedUser",
        label: "Assigned User",
        align: "left",
        field: "usersName",
        sortable: true,
      },
      {
        name: "type",
        label: "Type",
        align: "left",
        field: "type",
        sortable: true,
      },
      {
        name: "depth",
        label: "Depth",
        align: "left",
        field: "startingDepth",
        sortable: true,
      },
      {
        name: "upperLimit",
        label: "Upper Limit",
        align: "left",
        field: "upperLimit",
        sortable: true,
      },
      {
        name: "lowerLimit",
        label: "Lower Limit",
        align: "left",
        field: "lowerLimit",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        field: "status",
        sortable: true,
      },
    ],

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    dataUploadLoading: false,

    // Filter
    filter: {
      search: "",
      organization_id: null,
      idList: [],
    },

    deletingSurveyID: null,
  }),
  beforeCreate() {
    this.$store.dispatch("loadScheduledSurveys");
    this.$store.dispatch("loadOrganizationSurveyLinks");
    this.$store.dispatch("loadTrailers");
  },
  mounted() {
    if (this.aGGridActionMenu == true) {
      this.$store.dispatch("setAGGridActionMenuState", {});
    }
    this.handleRoute();
  },
  watch: {
    $route: function () {
      this.handleRoute();
    },
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`/surveys/${row.id}`);
    },
    handleRoute() {
      if (this.$route.params.surveys_id) {
        this.$store.dispatch("loadSurveyByID", this.$route.params.surveys_id);
        setTimeout(() => {
          this.viewDetailsDialog = true;
        }, 20);
      } else {
        this.viewDetailsDialog = false;
      }
    },
    close() {
      this.$router.push(`/surveys`);
    },
    organizationFilterChanged(id) {
      this.filter.organization_id = id;
      this.filter.idList = this.organizationSurveyLinks
        .filter((osl) => osl.organizations_id == id)
        .map((d) => d.surveys_id)
        .flat();
    },
    externalFilter(rows, terms, cols) {
      return rows.filter((row) => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "") {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Status Filter
        if (
          this.filter.idList.includes(row.id) ||
          this.filter.organization_id == null
        ) {
          passed += 1;
        }

        if (passed == 2) {
          return true;
        } else {
          return false;
        }
      });
    },
    archiveSurvey(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this survey, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#3284E3",
      }).then((res) => {
        if (res.value) {
          this.deletingSurveyID = id;
          let payload = {
            id: id,
            status: "deleted",
          };
          this.$store
            .dispatch("saveScheduledSurvey", payload)
            .then((result) => {
              this.deletingSurveyID = null;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Survey has been archived",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
